module.exports = __webpack_public_path__ + "static/media/17UN-Women4.cb92178b.jpg";